import { defineAsyncComponent } from 'vue'
export default {
  centered: defineAsyncComponent(() => import("/home/runner/work/RememoWeb/RememoWeb/layouts/centered.vue").then(m => m.default || m)),
  clean: defineAsyncComponent(() => import("/home/runner/work/RememoWeb/RememoWeb/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/RememoWeb/RememoWeb/layouts/default.vue").then(m => m.default || m))
}